import initScrollReveal from "./scripts/scrollReveal";
import initBoot from "./scripts/boot";
import initNav from "./scripts/nav";
import initMatrix from "./scripts/matrix";
import initTyping from "./scripts/typing";
import initStats from "./scripts/stats";
import initWorks from "./scripts/works";
import initTerminal from "./scripts/terminal";
import initEasterEggs from "./scripts/easterEggs";
import initTiltEffect from "./scripts/tiltAnimation";
import initFireworks from "./scripts/fireworks";

// 启动顺序：先渲染显现、再开机动画、后挂载交互
initScrollReveal();
const matrix = initMatrix();
initBoot();
initNav();
initTyping();
initStats();
initWorks();
initTerminal(matrix);
initEasterEggs(matrix);
initTiltEffect();
initFireworks();
